import React from 'react';
import { EnrollmentTracker } from './enrollment-tracker';
import { MainLayout, LayoutProps } from './layout';
import Banner from '../banner';
import RichText from '../rich-text';
import BackButton from '../back';

interface EnrollmentLayoutProps extends LayoutProps {
	title?: string;
    isBackButton?: boolean;
}

export const EnrollmentLayout: React.FC<EnrollmentLayoutProps> = ({
	children,
    label,
	mlrVersion,
	title,
    isBackButton = true
}) => {
    return (
        <MainLayout 
            label={label}
            mlrVersion={mlrVersion}
        >
            <Banner>
				<h1 id="banner-title-content">
                	{ title && <RichText html={title} /> }
				</h1>
                <EnrollmentTracker />
            </Banner>
            <div className="max-w-6xl mx-auto flex flex-col items-center justify-center px-6 pt-3.5 pb-16 md:pt-12 md:pb-24 lg:px-2 gap-5 lg:gap-3">
                { isBackButton && <BackButton /> }
                { children }
            </div>
        </MainLayout>
    )
}
